<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RightContent from '@/components/DailyReportEdit/Combine/RightContent.vue';
import DeliveryPlan from "@/types/DeliveryPlan";
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: (DeliveryPlan | getDeliveryPlanVehicleInformation)[]
  deliveryPlan: getDeliveryPlanVehicleInformation
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const isLastContent = computed(() => (index: number) => {
  return index === modelValue.value.length - 1;
})
</script>
<template>
  <v-card
    class="w-100 mb-8"
  >
    <div class="w-100 d-flex">
      <h3 class="mx-auto">
        {{ i18n.global.t('pages.dailyReports.combineForm.rightPane.title') }}
      </h3>
    </div>
    <template
      v-for="(selectedDeliveryPlan, index) in modelValue"
      :key="selectedDeliveryPlan.delivery_plan_id"
    >
      <div
        class="mx-auto my-5"
        :class="isLastContent(index) ? 'mb-8' : ''"
        style="width: 80%;"
      >
        <RightContent
          v-model="modelValue"
          :originDeliveryPlan="props.deliveryPlan"
          :deliveryPlan="selectedDeliveryPlan"
        />
      </div>
    </template>
  </v-card>
</template>
